import { api } from '../../../shared/services/api/client';

/**
 * Get usage statistics (passes, rewards, emails, tier, limits)
 */
export const getUsage = () => {
    return api.get('/tier/usage');
};


